import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

export const auraRoutes: Routes = [
  {
    path: 'apps',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('aura-app-switcher/Module')
        .then((m) => m.RemoteEntryModule)
        .catch((e) => console.log({ e })),
  },
  {
    path: '',
    outlet: 'app-bar',
    loadChildren: () =>
      import('aura-app-bar/Module')
        .then((m) => m.RemoteEntryModule)
        .catch((e) => console.log({ e })),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('aura-profile/Module').then((m) => m.RemoteEntryModule),
  },
];
